import React from 'react'
import { Form } from 'react-bootstrap'

const toSectionLabel = (sectionId) =>
  String(sectionId || "")
    .replace(/^task_/, "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

const getSectionOptions = (sectionOptions = [], selectedSections = []) => {
  if (Array.isArray(sectionOptions) && sectionOptions.length > 0) {
    return sectionOptions;
  }

  return (selectedSections || []).map((sectionId) => ({
    id: sectionId,
    label: toSectionLabel(sectionId),
  }));
};

const LaborRightContent = ({
  selectedSections = [],
  sectionOptions = [],
  onToggleSection,
}) => {
  const options = getSectionOptions(sectionOptions, selectedSections);

  if (!options.length) {
    return (
      <div className="right-tab-section d-flex align-items-center gap-3">
        <h3 className='d-flex align-items-center gap-2 mb-0'>
          <img src="/assets/images/invoice-user-icon.svg" alt="" />
          <span className='font-16 font-weight-bold heading-color'>No labor tasks bound</span>
        </h3>
      </div>
    );
  }

  return (
    <div>
        {options.map((section) => (
            <div className="right-tab-section d-flex align-items-center gap-3" key={section.id}>
                <Form.Check
                    type="checkbox"
                    checked={selectedSections.includes(section.id)}
                    onChange={() => onToggleSection?.(section.id)}
                />
                <h3 className='d-flex align-items-center gap-2 mb-0'>
                    <img src="/assets/images/invoice-user-icon.svg" alt="" />
                    <span className='font-16 font-weight-bold heading-color'>{section.label}</span>
                </h3>
            </div>
        ))}
    </div>
  )
}

export default LaborRightContent
